import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import styles from "./ClaPage.module.css";
import { ClaConnectedChatMessages } from "./components/ClaConnectedChatMessages.tsx";
import { ConnectedChatBox } from "./components/ConnectedChatBox.tsx";

export const ClaPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (!id) {
      navigate("/workflows/new");
    }
  }, [id, navigate]);
  return (
    <div className={styles.ClaContainer}>
      {id && id !== "new" && <ClaConnectedChatMessages chatId={id} />}
      {id === "new" && (
        <div className={styles.NewChatTitle}>
          Hi there! Ready to dive into your research?
        </div>
      )}
      <ConnectedChatBox />
    </div>
  );
};
